import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from "axios";
import mime from 'mime';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { CifradoAES, CifradoRSA } from "../../components/FuncionesCifrado";
//import Actions from "./Actions";
import { BASE_URL } from "../../config/api";

const Drive = ({ files, movil, ubicacion, pkey, activeTab, activeType, obtenerArchivos, cambiarUbicacion, regresarDirectorio, idCarpeta }) => {
  //
  //const [movil, setMovil] = useState(movil);
  //const [files, setFiles] = useState([]);
  //const [activeTab, setActiveTab] = useState(activeTab);
  //const [activeType, setActiveType] = useState(activeType);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [alert, setAlert] = useState([{msg:'', type:'', or:''}]);
  const [vistaActual, setVistaActual] = useState('detalles');
  const [menuContextual, setMenuContextual] = useState([]);
  const [tipoFiltro, setTipoFiltro] = useState('fecha');
  const [mayorMenor, setMayorMenor] = useState(1);
  //const [busqueda, setBusqueda] = useState(busqueda);
  //archivo
  const [carpetaMover, setCarpetaMover] = useState('');
  const [archivoMover, setArchivoMover] = useState([]);
  const [archivoShare, setArchivoShare] = useState([]);
  const [breadcrumb, setBreadcrumb] = useState([]);
  const [deleteFile, setDeleteFile] = useState([]);
  const [errorFile, setErrorFile] = useState('');
  const [pg, setPg] = useState(0);
  const [shareUrl, setShareUrl] = useState('');
  const [copy, setCopy] = useState(false);
  //
  //const [totalFiles, setTotalFiles] = useState(0);
  const [tipoArchivo, setTipoArchivo] = useState([
      {tipo:"audio",icono:'bi-file-music'},
      {tipo:"video",icono:'bi-file-video'},
      {tipo:"mp4",icono:'bi-filetype-mp4'},
      {tipo:"html",icono:'bi-filetype-html'},
      {tipo:"jpg",icono:'bi-filetype-jpg'},
      {tipo:"jpeg",icono:'bi-filetype-jpg'},
      {tipo:"png",icono:'bi-filetype-png'},
      {tipo:"plain",icono:'bi-filetype-txt'},
      {tipo:"zip",icono:'bi-file-earmark-zip'},
      {tipo:"docx",icono:'bi-filetype-docx'},
      {tipo:"doc",icono:'bi-filetype-doc'},
      {tipo:"xlsx",icono:'bi-filetype-xlsx'},
      {tipo:"xls",icono:'bi-filetype-xls'},
      {tipo:"csv",icono:'bi-filetype-csv'},
      {tipo:"pptx",icono:'bi-filetype-pptx'},
      {tipo:"ppt",icono:'bi-filetype-ppt'},      
      {tipo:"image",icono:'bi-file-earmark-image'},
      {tipo:"php",icono:'bi-filetype-php'},
      {tipo:"js",icono:'bi-filetype-js'},
      {tipo:"json",icono:'bi-filetype-json'},
      {tipo:"jsx",icono:'bi-filetype-jsx'},
      {tipo:"null",icono:'bi-file'}
  ]);
  const [statusDw, setStatusDw] = useState('');
  const [errorDw, setErrorDw] = useState(''); 
  const [selectedFiles, setSelectedFiles] = useState(new Set());
  const [selectedDirs, setSelectedDirs] = useState(new Set());
  const [selectMode, setSelectMode] = useState(false);
  const tokenSeguridad = 'xjC237RGCVCjFC6T8o25BScT2E3H9iPACvoPwn3RHB8ZHsZzmsnqJrydG4MrZrWLFXyKbU244vJYjMTTGSTB4cJDubWr8S7azn4fAJfRA6M3GQZDRi3LZbUXLqTV5DHi';
  
  // Refs for DOM elements
  const containerRef = useRef(null);
  const fileInputRef = useRef(null);
  const uploadWindowRef = useRef(null);
  const uploadListRef = useRef(null);
  const newFolderInput = useRef(null);
  const prevactiveTab = useRef();
  
  // Constants
  const publicKeyRSA = pkey;
  const aesEncryption = new CifradoAES();
  const rsaEncryption = new CifradoRSA();

  // Initialize folder input attributes
  useEffect(() => {
      if (containerRef.current) {
          const div = containerRef.current;
          div.setAttribute("webkitdirectory", "");
          div.setAttribute("mozdirectory", "");
          div.setAttribute("msdirectory", "");
          div.setAttribute("odirectory", "");
          div.setAttribute("directory", "");
      }
      if (showModal && modalType === 'addFolder') {
          setTimeout(() => {
              newFolderInput.current?.focus();
          }, 0);
      }
  }, [showModal, modalType]);
  // Fetch files when tab changes
  useEffect(() => {
    const prevTab = prevactiveTab.current;
    if (pkey !== '') {
      obtenerArchivos(activeTab);
    }
    if (prevTab !== activeTab) {
      setBreadcrumb([]);
      prevactiveTab.current = activeTab;
    } 
  }, [pkey, activeTab, obtenerArchivos]);
  //
  useEffect(() => {
    if (archivoShare.length > 0) {
      compartirArchivos();
    }
  }, [archivoShare]);
  /* useEffect(() => {
    setShowAlert(true);
  }, [alert]); */

  // Utility functions
  const formatBytes = useCallback((bytes, decimals = 2) => {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }, []);

  const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  const cambioFiltro = (filtro, numero) => {
    let arrayOrdenado;
    arrayOrdenado = JSON.parse(JSON.stringify(files.files));

    let tipo = "";
    if (filtro == "nombre") {
      tipo = "nombre"
    }
    else if (filtro == "tamaño") {
      tipo = "tamanio";
    }
    else if (filtro == "tipo") {
      tipo = "tipo";
    }
    else {
      tipo = "fecha";
    }

    arrayOrdenado.sort((a, b) => {
      if (a[tipo] == null) {
        a[tipo] = 'z';
      }
      if (b[tipo] == null) {
        b[tipo] = 'z';
      }

      if (a[tipo] > b[tipo]) {
        return 1 * numero;
      }
      if (a[tipo] < b[tipo]) {
        return -1 * numero;
      }
      // a must be equal to b
      return 0;
    });
    let temp = files;
    temp.files = arrayOrdenado;
    setTipoFiltro(filtro);
    setMayorMenor(numero);
    files = temp;
  }
  const cambioMayorMenor = (tipoFiltro) => {
    let numero = mayorMenor * -1;
    cambioFiltro(tipoFiltro, numero);
  }

  const handleFileSelect = (fileId) => {
    const newSelected = new Set(selectedFiles);
    if (newSelected.has(fileId)) {
      newSelected.delete(fileId);
    } else {
      newSelected.add(fileId);
    }
    setSelectedFiles(newSelected);
  }

  const handleDirSelect = (dirId) => {
    const newSelected = new Set(selectedDirs);
    if (newSelected.has(dirId)) {
      newSelected.delete(dirId);
    } else {
      newSelected.add(dirId);
    }
    console.log(newSelected);
    setSelectedDirs(newSelected);
  }

  const handleSelectAll = () => {
    const currentArray = activeType === 'files' 
      ? files.files 
      : files.img;
    
    const arrayDir = files.directories;
    
    if (selectedFiles.size === currentArray?.length) {
      // Deselect all
      setSelectedFiles(new Set());
    } else {
      // Select all
      const allIds = new Set(currentArray?.map(file => file.id_archivo_unico) || []);
      setSelectedFiles(allIds);
    }

    if (selectedDirs.size === arrayDir?.length) {
      // Deselect all
      setSelectedDirs(new Set());
    } else {
      // Select all
      const allDirIds = new Set(arrayDir?.map(dir => dir.id_carpeta) || []);
      setSelectedDirs(allDirIds);
    }
  }

  const toggleSelectMode = () => {
    setSelectMode(!selectMode);
    setSelectedDirs(new Set());
    setSelectedFiles(new Set());
  }

  const unSelect = () => {
    setSelectedDirs(new Set());
    setSelectedFiles(new Set());
  }
  const handleModal = (type) =>{
    setModalType(type);
    setShowModal(true);
  };
  /* getSelectedFileObjects = () => {
    const currentArray = activeType === 'files' 
      ? directorioArchivos.files 
      : directorioArchivos.img;
    
    return currentArray?.filter(file => selectedFiles.has(file.id_archivo_unico)) || [];
  } */
  // funciones archivo
  const descargarArchivo = async (id_archivo, archivo, tamanio_archivo) => {
    try {
      handleModal('dw');
      
      const formData = new FormData();
      formData.append("id_usuario", sessionStorage.getItem('id_usuario'));
      formData.append("t_u", sessionStorage.getItem('token_nk107803'));
      formData.append("tip_u", sessionStorage.getItem('tipo_usuario'));
      formData.append("t_seg", tokenSeguridad);
      formData.append("ubicacion", ubicacion);
      formData.append("archivo", archivo);
      formData.append("id_archivo", id_archivo);
      
      // Cifrando Envío
      for (let dato of formData.entries()) {
        formData.set(dato[0], aesEncryption.cifrar(dato[1]).datos);
      }
      
      let llaveCifrada = await rsaEncryption.cifrar(aesEncryption.llave, publicKeyRSA);
      formData.append("ivCifradoSimetrico", aesEncryption.iv);
      formData.append("keyCifradoSimetrico", llaveCifrada);

      const url = `${BASE_URL}/cratos/ModuloDrive/PHP/Implementaciones/descargarArchivo.php`;
      
      const response = await axios({
        url: url,
        method: "POST",
        data: formData,
        responseType: "blob",
        onDownloadProgress: (progressEvent) => {
          const pg = Math.round((progressEvent.loaded * 100) / parseFloat(tamanio_archivo));
          setPg(pg);
        },
      });

      // Check if response is JSON error (not a file blob)
      const contentType = response.headers['content-type'];
      if (contentType && contentType.includes('application/json')) {
        const text = await response.data.text();
        const datos = JSON.parse(text);
        
        if (datos.success === false) {
          setTimeout(() => {
            setShowModal(false);
            setAlert([{ msg: datos.message, type: 'danger', or: 'Descarga' }]);
            setShowAlert(true);
            setPg(0);
          }, 500);
          return;
        }
      }

      // Download the file
      const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", archivo);
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
      
      setTimeout(() => {
        setShowModal(false);
        setPg(0);
      }, 500);
      
    } catch (error) {
      console.error('Error descargando archivo:', error);
      setTimeout(() => {
        setShowModal(false);
        setAlert([{ msg: error.message || 'Error al descargar el archivo', type: 'danger', or: 'Descarga' }]);
        setShowAlert(true);
        setPg(0);
      }, 500);
    }
  };
  const mover = (id, nombre, tipo) =>{
    if (tipo == 'moveMultiple') {
      const files = [...selectedFiles];
      const dirs = [...selectedDirs];
      setArchivoMover([files, dirs]);
    }else{
      const files = [id];
      const dirs = [];
      setArchivoMover([files, dirs]);
    }    
    setModalType('move');
    setShowModal(true);
  };
  const moverArchivos = async() => {
    const formData = new FormData();
    formData.append("id_usuario", sessionStorage.getItem('id_usuario'));
    formData.append("t_u", sessionStorage.getItem('token_nk107803'));
    formData.append("tip_u", sessionStorage.getItem('tipo_usuario'));
    formData.append("t_seg", tokenSeguridad);
    formData.append("ubicacion_nueva", ubicacion);
    formData.append("id_carpeta", idCarpeta);
    formData.append("files", JSON.stringify(archivoMover[0]));
    formData.append("dirs", JSON.stringify(archivoMover[1]));

    console.log(formData.entries());
   
    //Cifrando Envío
    for (let dato of formData.entries()) {
      console.log(dato);
      formData.set(dato[0], aesEncryption.cifrar(dato[1]).datos)
    }
    let llaveCifrada = await rsaEncryption.cifrar(aesEncryption.llave, publicKeyRSA);
    formData.append("ivCifradoSimetrico", aesEncryption.iv);
    formData.append("keyCifradoSimetrico", llaveCifrada);

    const url = `${BASE_URL}/cratos/ModuloDrive/PHP/Implementaciones/moverArchivo.php`;
    fetch(url, {
        method: 'POST',
        body: formData
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text(); // Get as text first to see what's actually returned
    })
    .then(text => {
        //console.log('Raw response:', text); // Debug: see raw response
        try {
            const data = JSON.parse(text);
            if (data.success) {
              setAlert([{msg:data.message, type:'success', or: 'Mover'}]);
              cambiarUbicacion?.('','/', activeTab);
              setShowModal(false);
              setShowAlert(true);
              //alert(data.message);
            } else {
              setAlert([{msg:data.message, type:'danger', or: 'Mover'}]);
              setShowAlert(true);
              console.error(`Error ${data.error}: ${data.message}`);
            }
        } catch (e) {
          setAlert([{msg:text, type:'danger', or: 'Mover'}]);
          setShowAlert(true);
          console.error('JSON parse error:', e, 'Response was:', text);
        }
    })
    .catch(error => {
        console.error('Fetch error:', error);
    });
  };
  const borrar = (id, nombre, tipo) => {
    if (tipo == 'deleteMultiple') {
      const files = [...selectedFiles];
      const dirs = [...selectedDirs];
      setDeleteFile([files, dirs]);
    }else if (tipo == 'deleteDir') {
      const files = [];
      const dirs = [id];
      setDeleteFile([files, dirs]);
    }else{
      const files = [id];
      const dirs = [];
      setDeleteFile([files, dirs]);
    }
    handleModal('delete');
  }
  const borrarArchivos = async() => {
    const formData = new FormData();
    formData.append("id_usuario", sessionStorage.getItem('id_usuario'));
    formData.append("t_u", sessionStorage.getItem('token_nk107803'));
    formData.append("tip_u", sessionStorage.getItem('tipo_usuario'));
    formData.append("t_seg", tokenSeguridad);
    formData.append("ubicacion", ubicacion);
    //formData.append("archivo", deleteFile[1]);
    //formData.append("id_archivo", deleteFile[0]);
    formData.append("files", JSON.stringify(deleteFile[0]));
    formData.append("dirs", JSON.stringify(deleteFile[1]));
    //Cifrando Envío
    for (let dato of formData.entries()) {
      console.log(dato);
      formData.set(dato[0], aesEncryption.cifrar(dato[1]).datos)
    }
    let llaveCifrada = await rsaEncryption.cifrar(aesEncryption.llave, publicKeyRSA);
    formData.append("ivCifradoSimetrico", aesEncryption.iv);
    formData.append("keyCifradoSimetrico", llaveCifrada);

    const url = `${BASE_URL}/cratos/ModuloDrive/PHP/Implementaciones/borrarArchivo.php`;
    fetch(url, {
        method: 'POST',
        body: formData
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text(); // Get as text first to see what's actually returned
    })
    .then(text => {
        console.log('Raw response:', text); // Debug: see raw response
        try {
            const data = JSON.parse(text);
            if (data.success) {
              obtenerArchivos(activeTab);
              setShowModal(false);
              return;
            } else {
             /*  setErrorFile('Error al borrar archivo'); */
              console.error(`Error ${data.error}: ${data.message}`);
            }
        } catch (e) {
          /* setAlert([{msg:text, type:'danger'}]);
          setShowAlert(true); */
          console.error('JSON parse error:', e, 'Response was:', text);
        }
    })
    .catch(error => {
        console.error('Fetch error:', error);
    });
    /* axios({
      url: url,
      method: "POST",
      data: formData,
      responseType: "text", // importante
    }).then((response) => {
      if (parseInt(response.data) == 1) {
        obtenerArchivos(activeTab);
        setShowModal(false);
        return;
      } else {
        setErrorFile('Error al borrar archivo');
        return;
      }
    }).catch(function (response) {
      alert("Error de conexión");
      console.log(response);
    }); */
  };
  const compartir = (id,tipo) => {
    if (tipo == 'shareMultiple') {
      const files = [...selectedFiles];
      const dirs = [...selectedDirs];
      setArchivoShare([files, dirs]);
    }else if (tipo == 'shareDir') {
      const files = [];
      const dirs = [id];
      setDeleteFile([files, dirs]);
    }else{
      const files = [id];
      const dirs = [];
      setArchivoShare([files, dirs]);
    }    
    setModalType('share');
    setShowModal(true);
  };
  const compartirArchivos = async () => {
    
    const formData = new FormData();
    formData.append("id_usuario", sessionStorage.getItem('id_usuario'));
    formData.append("t_u", sessionStorage.getItem('token_nk107803'));
    formData.append("tip_u", sessionStorage.getItem('tipo_usuario'));
    formData.append("t_seg", tokenSeguridad);
    formData.append("ubicacion", ubicacion);
    formData.append("files", JSON.stringify(archivoShare[0]));
    formData.append("dirs", JSON.stringify(archivoShare[1]));
    //Cifrando Envío
    for (let dato of formData.entries()) {
      formData.set(dato[0], aesEncryption.cifrar(dato[1]).datos)
    }
    let llaveCifrada = await rsaEncryption.cifrar(aesEncryption.llave, publicKeyRSA);
    formData.append("ivCifradoSimetrico", aesEncryption.iv);
    formData.append("keyCifradoSimetrico", llaveCifrada);

    const url = `${BASE_URL}/cratos/ModuloDrive/PHP/Implementaciones/compartirArchivo.php`;
    fetch(url, {
        method: 'POST',
        body: formData
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text(); // Get as text first to see what's actually returned
    })
    .then(text => {
        console.log('Raw response:', text); // Debug: see raw response
        try {
            const data = JSON.parse(text);
            if (data.success) {
              setShareUrl(data.url[0]);
              return;
            } else {
             /*  setErrorFile('Error al borrar archivo'); */
              console.error(`Error ${data.error}: ${data.message}`);
            }
        } catch (e) {
          /* setAlert([{msg:text, type:'danger'}]);
          setShowAlert(true); */
          console.error('JSON parse error:', e, 'Response was:', text);
        }
    })
    .catch(error => {
        console.error('Fetch error:', error);
    });
  };
  const terminarCompartir = async (id) => {
    
    const formData = new FormData();
    formData.append("id_usuario", sessionStorage.getItem('id_usuario'));
    formData.append("t_u", sessionStorage.getItem('token_nk107803'));
    formData.append("tip_u", sessionStorage.getItem('tipo_usuario'));
    formData.append("t_seg", tokenSeguridad);
    formData.append("id_archivo", id);
    formData.append("end", 1);
    //Cifrando Envío
    for (let dato of formData.entries()) {
      formData.set(dato[0], aesEncryption.cifrar(dato[1]).datos)
    }
    let llaveCifrada = await rsaEncryption.cifrar(aesEncryption.llave, publicKeyRSA);
    formData.append("ivCifradoSimetrico", aesEncryption.iv);
    formData.append("keyCifradoSimetrico", llaveCifrada);

    const url = `${BASE_URL}/cratos/ModuloDrive/PHP/Implementaciones/compartirArchivo.php`;
    fetch(url, {
        method: 'POST',
        body: formData
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text(); // Get as text first to see what's actually returned
    })
    .then(text => {
        console.log('Raw response:', text); // Debug: see raw response
        try {
            const data = JSON.parse(text);
            if (data.success) {
              setAlert([{msg:'Se termino de compartir el archivo correctamente.', type:'success', or: 'Compartidos'}]);
              obtenerArchivos(activeTab);
            } else {
             /*  setErrorFile('Error al borrar archivo'); */
              console.error(`Error ${data.error}: ${data.message}`);
            }
        } catch (e) {
          /* setAlert([{msg:text, type:'danger'}]);
          setShowAlert(true); */
          console.error('JSON parse error:', e, 'Response was:', text);
        }
    })
    .catch(error => {
        console.error('Fetch error:', error);
    });
    return;
  };
  const descargarCarpeta = async (id,nombre) => {
     
      const formData = new FormData();
      formData.append("id_usuario", sessionStorage.getItem('id_usuario'));
      formData.append("t_u", sessionStorage.getItem('token_nk107803'));
      formData.append("tip_u", sessionStorage.getItem('tipo_usuario'));
      formData.append("t_seg", tokenSeguridad);
      formData.append("ubicacion", ubicacion);
      formData.append("id_carpeta", id);
      formData.append("nombre", nombre);
     
      //Cifrando Envío
      for (let dato of formData.entries()) {
        formData.set(dato[0], aesEncryption.cifrar(dato[1]).datos)
      }
      let llaveCifrada = await rsaEncryption.cifrar(aesEncryption.llave, publicKeyRSA);
      formData.append("ivCifradoSimetrico", aesEncryption.iv);
      formData.append("keyCifradoSimetrico", llaveCifrada);
  
      const url = `${BASE_URL}/cratos/ModuloDrive/PHP/Implementaciones/listarCarpeta.php`;
      setModalType('dwDir');
      setShowModal(true);

      if (id === ''){
        setAlert([{msg:'Sin carpeta.', type:'danger', or: 'Descarga'}]);
        setShowAlert(true);
        return;
      }

      setErrorDw('');
      setStatusDw('Listando archivos en carpeta: '+nombre+'...');
      setPg(0);
      try {
        const response = await axios({
          url: url,
          method: "POST",
          data: formData,
          responseType: "json" // Changed to json for automatic parsing
        });

        // Validate response exists
        if (!response || !response.data) {
          throw new Error('Respuesta vacía del servidor');
        }

        const datos = response.data;

        // Check if response indicates an error (value of 0 or error structure)
        if (datos === 0 || datos === "0") {
          throw new Error('El servidor respondió con un error');
        }

        // Check if there are errors in the response
        if (datos.errors && datos.errors.length > 0) {
          console.error('Errores obteniendo información de la carpeta:', datos.errors);
          setErrorDw(`Error obteniendo información de la carpeta: ${datos.errors.join(', ')}`);
          setStatusDw('');
          setPg(0);
          return;
        }

        // Validate required fields
        if (!datos.summary.total_size) {
          throw new Error('Resumen no disponible');
        }

        let total = datos.summary.total_size;
        if (total > 5000000000) {
          throw new Error('No se puede descargar, la carpeta supera los 5GB.');
        }
        // Success - initiate download
        comprimirCarpeta(id,nombre);

      } catch (error) {
        console.error('Error en descargarCarpeta:', error);

        // Handle different error types
        let errorMessage = 'Ocurrió un error inesperado. Intente de nuevo más tarde.';

        if (error.response) {
          // Server responded with error status
          if (error.response.status === 404) {
            errorMessage = 'Archivo o carpeta no encontrado.';
          } else if (error.response.status === 403) {
            errorMessage = 'No tiene permisos para realizar esta acción.';
          } else if (error.response.status === 500) {
            errorMessage = 'Error interno del servidor.';
          } else if (error.response.data?.message) {
            errorMessage = error.response.data.message;
          }
        } else if (error.request) {
          // Request made but no response
          errorMessage = 'No se pudo conectar con el servidor. Verifique su conexión.';
        } else if (error.code === 'ECONNABORTED') {
          errorMessage = 'La operación tardó demasiado. Intente con archivos más pequeños.';
        } else if (error.message) {
          errorMessage = error.message;
        }

        setErrorDw(errorMessage);
        setStatusDw('');
        setPg(0);
      }
     return;
  };
  const comprimirCarpeta = async (id,nombre) => {
    // Reset states
    setErrorDw('');
    setStatusDw('Preparando descarga...');
    setPg(0);

    const formData = new FormData();
    formData.append("id_usuario", sessionStorage.getItem('id_usuario'));
    formData.append("t_u", sessionStorage.getItem('token_nk107803'));
    formData.append("tip_u", sessionStorage.getItem('tipo_usuario'));
    formData.append("t_seg", tokenSeguridad);
    formData.append("ubicacion", ubicacion);
    formData.append("id_carpeta", id);
    formData.append("nombre", nombre);
    
    //Cifrando Envío
    for (let dato of formData.entries()) {
      formData.set(dato[0], aesEncryption.cifrar(dato[1]).datos)
    }
    let llaveCifrada = await rsaEncryption.cifrar(aesEncryption.llave, publicKeyRSA);
    formData.append("ivCifradoSimetrico", aesEncryption.iv);
    formData.append("keyCifradoSimetrico", llaveCifrada);

    const url = `${BASE_URL}/cratos/ModuloDrive/PHP/Implementaciones/comprimirCarpeta.php`;

    try {
      const response = await axios({
        url: url,
        method: "POST",
        data: formData,
        responseType: "json", // Changed to json for automatic parsing
        timeout: 300000, // 5 minute timeout for large files
        onUploadProgress: (progressEvent) => {
          // Optional: track upload progress if needed
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          console.log('Upload progress:', percentCompleted);
        }
      });

      // Validate response exists
      if (!response || !response.data) {
        throw new Error('Respuesta vacía del servidor');
      }

      const datos = response.data;

      // Check if response indicates an error (value of 0 or error structure)
      if (datos === 0 || datos === "0") {
        throw new Error('El servidor respondió con un error');
      }

      // Handle new response structure with success flag
      if (datos.success === false) {
        const errorMsg = datos.message || 'Error desconocido';
        const errors = datos.errors || [];
        console.error('Errores al comprimir:', errors);
        setErrorDw(`Error: ${errorMsg}`);
        setStatusDw('');
        setPg(0);
        return;
      }

      // Check if there are errors in the response (legacy format)
      if (datos.errors && datos.errors.length > 0 && !datos.success) {
        console.error('Errores al comprimir:', datos.errors);
        setErrorDw(`Error al comprimir: ${datos.errors.join(', ')}`);
        setStatusDw('');
        setPg(0);
        return;
      }

      // Extract data from new structure or use legacy format
      let downloadData;
      if (datos.data && typeof datos.data === 'object') {
        // New structure: { success: true, data: { url, files, ... } }
        downloadData = datos.data;
      } else if (datos.url) {
        // Legacy structure: { url, files, ... }
        downloadData = datos;
      } else {
        throw new Error('URL de descarga no disponible');
      }

      // Validate URL exists
      if (!downloadData.url) {
        throw new Error('URL de descarga no disponible');
      }

      // Success - initiate download
      setErrorDw('');
      setStatusDw('Iniciando descarga...');
      iniciarDescarga(downloadData);

    } catch (error) {
      console.error('Error en comprimirCarpeta:', error);

      // Handle different error types
      let errorMessage = 'Ocurrió un error inesperado. Intente de nuevo más tarde.';

      if (error.response) {
        // Server responded with error status
        if (error.response.status === 404) {
          errorMessage = 'Archivo o carpeta no encontrado.';
        } else if (error.response.status === 403) {
          errorMessage = 'No tiene permisos para realizar esta acción.';
        } else if (error.response.status === 500) {
          errorMessage = 'Error interno del servidor.';
        } else if (error.response.data?.message) {
          errorMessage = error.response.data.message;
        }
      } else if (error.request) {
        // Request made but no response
        errorMessage = 'No se pudo conectar con el servidor. Verifique su conexión.';
      } else if (error.code === 'ECONNABORTED') {
        errorMessage = 'La operación tardó demasiado. Intente con archivos más pequeños.';
      } else if (error.message) {
        errorMessage = error.message;
      }

      setErrorDw(errorMessage);
      setStatusDw('');
      setPg(0);
    }
  };
  const iniciarDescarga = async (datos) => {
    try {
      // Validate input data
      if (!datos || !datos.url) {
        throw new Error('Datos de descarga inválidos');
      }

      if (!datos.totalSize || datos.totalSize <= 0) {
        console.warn('Total size not provided, progress tracking may be inaccurate');
      }

      // Validate session data
      const id_usuario = sessionStorage.getItem('id_usuario');
      const token_nk = sessionStorage.getItem('token_nk107803');
      const tip_u = sessionStorage.getItem('tipo_usuario');

      if (!id_usuario || !token_nk || !tip_u) {
        throw new Error('Sesión inválida o expirada. Por favor, inicie sesión nuevamente.');
      }

      if (!tokenSeguridad) {
        throw new Error('Token de seguridad no disponible');
      }

      setStatusDw('Preparando descarga segura...');
      setPg(0);

      // Prepare form data
      const formData = new FormData();
      formData.append("id_usuario", id_usuario);
      formData.append("t_u", token_nk);
      formData.append("tip_u", tip_u);
      formData.append("t_seg", tokenSeguridad);
      formData.append("archivo", datos.url);

      // Encrypt data
      setStatusDw('Cifrando datos...');
      
      // Encrypt form data
      for (let dato of formData.entries()) {
        try {
          const encrypted = aesEncryption.cifrar(dato[1]);
          if (!encrypted || !encrypted.datos) {
            throw new Error('Error en el cifrado de datos');
          }
          formData.set(dato[0], encrypted.datos);
        } catch (encryptError) {
          throw new Error(`Error al cifrar ${dato[0]}: ${encryptError.message}`);
        }
      }

      // Encrypt AES key with RSA
      let llaveCifrada;
      try {
        llaveCifrada = await rsaEncryption.cifrar(aesEncryption.llave, publicKeyRSA);
        if (!llaveCifrada) {
          throw new Error('Error al cifrar la llave de sesión');
        }
      } catch (rsaError) {
        throw new Error(`Error en cifrado RSA: ${rsaError.message}`);
      }

      formData.append("ivCifradoSimetrico", aesEncryption.iv);
      formData.append("keyCifradoSimetrico", llaveCifrada);

      setStatusDw('Descargando archivo...');

      const url = `${BASE_URL}/cratos/ModuloDrive/PHP/Implementaciones/descargarCarpeta.php`;
      
      const response = await axios({
        url: url,
        method: "POST",
        data: formData,
        responseType: "blob",
        timeout: 600000, // 10 minute timeout for large files
        onDownloadProgress: (progressEvent) => {
          if (datos.totalSize && datos.totalSize > 0) {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / parseFloat(datos.totalSize));
            setPg(Math.min(percentCompleted, 100)); // Cap at 100%
            setStatusDw(`Descargando... ${percentCompleted}%`);
          } else if (progressEvent.total) {
            // Fallback to event.total if available
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setPg(Math.min(percentCompleted, 100));
            setStatusDw(`Descargando... ${percentCompleted}%`);
          } else {
            // If no total size, just show loaded bytes
            const loadedMB = (progressEvent.loaded / 1024 / 1024).toFixed(2);
            setStatusDw(`Descargado: ${loadedMB} MB`);
          }
        }
      });

      // Validate response
      if (!response || !response.data) {
        throw new Error('Respuesta vacía del servidor');
      }

      // Check if response is an error (small blob that might be text)
      if (response.data.size < 100) {
        // Might be an error message, check if it's "0" or error text
        const text = await response.data.text();
        if (text === '0' || text === 0 || text.trim() === '0') {
          throw new Error('El archivo no está disponible o fue eliminado');
        }
        // If it's JSON error response
        try {
          const errorData = JSON.parse(text);
          if (errorData.error || errorData.message) {
            throw new Error(errorData.message || errorData.error || 'Error en la descarga');
          }
        } catch (jsonError) {
          // Not JSON, might be legitimate small file, continue
        }
      }

      setStatusDw('Guardando archivo...');
      setPg(100);

      // Create download link
      const blobUrl = URL.createObjectURL(new Blob([response.data]));
      const downloadLink = document.createElement('a');
      
      // Extract filename from datos.url or use default
      let fileName = datos.url;
      if (fileName.includes('/')) {
        fileName = fileName.split('/').pop();
      }
      // Sanitize filename
      const safeFileName = fileName.replace(/[/\\?%*:|"<>]/g, '_');
      
      downloadLink.href = blobUrl;
      downloadLink.download = safeFileName;
      downloadLink.style.display = 'none';
      
      // Append, click, and remove
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

      // Success feedback
      setStatusDw('Descarga completada');
      setErrorDw('');
      
      // Show success stats if available
      if (datos.files || datos.directories) {
        const statsMsg = `Archivos: ${datos.files || 0}, Carpetas: ${datos.directories || 0}`;
        console.log('Descarga completada:', statsMsg);
      }

      // Cleanup and close modal
      setTimeout(() => {
        URL.revokeObjectURL(blobUrl);
        setShowModal(false);
        setPg(0);
        setStatusDw('');
      }, 1500);

    } catch (error) {
      console.error('Error en iniciarDescarga:', error);

      // Handle different error types
      let errorMessage = 'Error al descargar el archivo.';

      if (error.response) {
        // Server responded with error
        if (error.response.status === 404) {
          errorMessage = 'Archivo no encontrado.';
        } else if (error.response.status === 403) {
          errorMessage = 'No tiene permisos para descargar este archivo.';
        } else if (error.response.status === 401) {
          errorMessage = 'Sesión expirada. Por favor, inicie sesión nuevamente.';
        } else if (error.response.status === 413) {
          errorMessage = 'El archivo es demasiado grande para descargar.';
        } else if (error.response.status === 500) {
          errorMessage = 'Error interno del servidor.';
        }
        
        // Try to get error message from response
        if (error.response.data) {
          try {
            const errorData = await error.response.data.text();
            const parsed = JSON.parse(errorData);
            if (parsed.message || parsed.error) {
              errorMessage = parsed.message || parsed.error;
            }
          } catch (parseError) {
            // Use default error message
          }
        }
      } else if (error.request) {
        // Request made but no response
        errorMessage = 'No se pudo conectar con el servidor. Verifique su conexión.';
      } else if (error.code === 'ECONNABORTED') {
        errorMessage = 'La descarga tardó demasiado tiempo. Intente de nuevo.';
      } else if (error.message) {
        errorMessage = error.message;
      }

      setErrorDw(errorMessage);
      setStatusDw('');
      setPg(0);
    }
  };
  //render
  const renderGrid = () => {
    let fileGrid = [];
    let arrayTemp;
    let arrayFiles = files.files;
    let arrayImg = files.img;
    let arrayDir = files.directories;
    let totalFiles = 0;
    let totalDir = 0;

    totalFiles = activeType === 'files' ? arrayFiles?.length : arrayImg?.length;
    totalDir = arrayDir?.length;
    arrayTemp = activeType === 'files' ? {...arrayFiles} : {...arrayImg};


    for (let index = 0; index < totalFiles; index++) {
      const file = arrayTemp[index];
      let f = '';
      let m = mime.getType(file.nombre);
      let icono = '';
      if (m == null) {
        f = 'null';
      }else{
        let a = m.split('/');
        if(a[0] == 'application'){
          f = mime.getExtension(m);
        }else{
          f = a[1];
        }
      }        
      let obj = tipoArchivo.find(o => o.tipo === f);
      if (obj != undefined) {
        icono = obj.icono;
      }else{
        icono = 'bi-file-earmark';
      }
      fileGrid.push(<div className="col">
        <div className="card h-100" 
          onContextMenu={() => {
            let menuContextual = (<>
              <li key={'option-dw-sq'+index} className="list-group-item">
                <button className="btn text-secondary"
                  onClick={() => { descargarArchivo(file.id_archivo_unico, file.nombre, file.tamanio) }}
                  data-bs-toggle="tooltip" data-bs-placement="top" title=""
                  >
                  <i className="bi bi-cloud-download"></i> Descargar
                </button>
              </li>
              <li key={'option-del-sq'+index} className="list-group-item">
                <button className="btn text-secondary"
                  onClick={() => { borrar(file.id_archivo_unico, file.nombre, 'delete'); }}
                  data-bs-toggle="tooltip" data-bs-placement="top" title=""
                  data-original-title="Delete">
                  <i className="bi bi-trash"></i> Borrar
                </button>
              </li>
            </>);
            setMenuContextual(menuContextual);
          }}
        >
          <div className="card-body p-1">
            <div className="text-center">{file.thumb ? <img src={'public/'+file.thumb} width={50}/> : <i className={'bi '+icono+' fs-3'}></i> }</div>
            <div className="card-title text-nowrap" style={{textOverflow: "ellipsis", overflow:"hidden"}}>
              {/* <a href="#" title={archivo.nombre} style={{color:"#212529"}}>{archivo.nombre}</a> */}
              <span title={file.nombre}>{file.nombre}</span>
            </div>
          </div>
          <div className="card-footer p-0">
            <div className="btn-group" role="group">
              <a className="btn " href="#" onClick={() => descargarArchivo(file.id_archivo_unico, file.nombre, file.tamanio)}
                data-bs-toggle="tooltip" data-bs-placement="top" title="Descargar"><i className="bi bi-cloud-download"></i></a>
              <a className="btn " href="#" onClick={() => {borrar(file.id_archivo_unico, file.nombre, 'delete');}} 
                data-bs-toggle="tooltip" data-bs-placement="top" title="Borrar"><i className="bi bi-trash"></i></a>
            </div>
          </div>
        </div>
      </div>);
    }
    
    return (
      <div className="row row-cols-2 row-cols-md-3 g-4 mt-1 text-center">
        {fileGrid}
      </div>
    );
  };
  const renderTop = (totalDir, totalFiles) => {
    const isAllSelected = selectedFiles.size === totalFiles && totalFiles > 0;
    const isIndeterminate = selectedFiles.size > 0 && selectedFiles.size < totalFiles;
    const isAllSelectedDir = selectedDirs.size === totalDir && totalDir > 0;
    const isIndeterminateDir = selectedDirs.size > 0 && selectedDirs.size < totalDir;
    
    return (
        <tr key={"selectRow"}>
          <th className="col-1 text-center">
            <input
              type="checkbox"
              className="form-check-input"
              checked={isAllSelected&&isAllSelectedDir}
              ref={(input) => {
                if (input) input.indeterminate = isIndeterminate && isIndeterminateDir;
              }}
              onChange={handleSelectAll}
            />
          </th>
          <th className="col-1 text-center"></th>
          <th className="col-8 text-center"></th>
          <th className="col-1 text-center"></th>
          <th className="col-1 text-center"></th>
        </tr>
    );
  };
  const renderList = () => {
    let fileDetails = [];
    let arrayTemp;
    let arrayFiles = files.files;
    let arrayImg = files.img;
    let arrayDir = files.directories;
    let totalFiles = 0;
    let totalDir = 0;

    totalFiles = activeType === 'files' ? arrayFiles?.length : arrayImg?.length;
    totalDir = arrayDir?.length;
    arrayTemp = activeType === 'files' ? {...arrayFiles} : {...arrayImg};

    if (totalFiles == 0 && totalDir == 0) {
      return (
        <div className="text-center h-100 w-100" style={{minHeight:'300px', paddingTop:'5%'}}>
          <span className='fs-3'>No hay nada 
            ¯\_(ツ)_/¯
          </span>
        </div>
      );
    }

    if (arrayDir) {
      for (let j = 0; j < totalDir; j++) {
        const archivo = arrayDir[j];
        const isSelected = selectedDirs.has(archivo.id_carpeta);
        
        fileDetails.push(
          <tr key={'dir-'+totalDir+'-'+j} onContextMenu={() => {
            let menuContextual = (<>
              <li key={'option-dwdir'+j} className="list-group-item">
                <button className="btn text-secondary"
                  onClick={() => { descargarCarpeta(archivo.id_carpeta, archivo.nombre) }}
                  data-bs-toggle="tooltip" data-bs-placement="top" title=""
                  >
                  <i className="bi bi-cloud-download"></i> Descargar Carpeta
                </button>
              </li>
              <li key={'option-deldir'+j} className="list-group-item">
                <button className="btn text-secondary"
                  onClick={() => { borrar(archivo.id_carpeta, archivo.nombre, 'deleteDir') }}
                  data-bs-toggle="tooltip" data-bs-placement="top" title=""
                  data-original-title="Delete">
                  <i className="bi bi-trash"></i> Borrar Carpeta
                </button>
              </li>
            </>);
            setMenuContextual(menuContextual);
          }} className={`border-bottom border-dark ${isSelected ? 'table-active' : ''}`}>
            {selectMode && (
              <td className="col align-middle text-center">
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={isSelected}
                  onChange={() => handleDirSelect(archivo.id_carpeta)}
                />
              </td>
            )}
            <td className="col-1 align-middle text-center" onClick={() => { cambiarUbicacion(archivo.id_carpeta, archivo.nombre, activeTab); setBreadcrumb(prev => [...prev, archivo.nombre]);}}>
              <i className="bi bi-folder-fill folder fs-3"></i></td>
            <td className="col-9" onClick={() => {cambiarUbicacion(archivo.id_carpeta, archivo.nombre, activeTab); setBreadcrumb(prev => [...prev, archivo.nombre]);}} >
              {/* <a href="#" onClick={() => {this.cambiardirectorio(archivo.nombre);}} style={{color:"#212529"}}>{decodeURIComponent(archivo.nombre)}</a> */}
              <span>{decodeURIComponent(archivo.nombre)}</span>
              <br></br>
              <span style={{fontSize:'small'}}>Carpeta</span>
            </td>
            <td className="col-1"></td>
            <td className="col-1 align-middle text-center">
              <div className="dropdown show">
                <a href="#" role="button" id="dropdownMenuArchivo" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{color:"#212529"}}>
                  <i className="bi bi-three-dots-vertical"></i>
                </a>
                <ul className="dropdown-menu" aria-labelledby="dropdownMenuArchivo">
                  <li key={'newdir'+j}><a className="dropdown-item" data-bs-toggle="modal" data-bs-target="#NuevaCarpetaModal" href="#"><i className="bi bi-folder-plus"></i> Carpeta Nueva</a></li>
                  <li key={'adddir'+j}><a className="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target="#SubirArchivos"><i className="bi bi-file-plus"></i> Agregar Archivos</a></li>
                  <li key={'divdir'+j}><hr className="dropdown-divider"/></li>
                  <li key={'dwdir'+j}><a onClick={() => { descargarCarpeta(archivo.id_carpeta, archivo.nombre) }}
                    className="dropdown-item" href="#"><i className="bi bi-cloud-download"></i> Descargar</a></li>
                  <li key={'shdir'+j}><a onClick={() => { compartirCarpeta(archivo.nombre); }}
                    className="dropdown-item" href="#"><i className="bi bi-share"></i> Compartir</a></li>
                  <li key={'dwdir2'+j}><hr className="dropdown-divider"/></li>
                  <li key={'deldir'+j}><a onClick={() => { borrar(archivo.id_carpeta, archivo.nombre, 'deleteDir'); }}
                    className="dropdown-item" href="#"><i className="bi bi-trash"></i> Borrar</a></li>
                </ul>
              </div>
            </td>
          </tr>
        );
      }
    }

    for (let index = 0; index < totalFiles; index++) {
      const file = arrayTemp[index];
      const isSelected = selectedFiles.has(file.id_archivo_unico);
      let f = '';
      let m = mime.getType(file.nombre);
      let icono = '';
      if (m == null) {
        f = 'null';
      }else{
        let a = m.split('/');
        if(a[0] == 'application'){
          f = mime.getExtension(m);
        }else{
          f = a[1];
        }
      }        
      let obj = tipoArchivo.find(o => o.tipo === f);
      if (obj != undefined) {
        icono = obj.icono;
      }else{
        icono = 'bi-file-earmark';
      }        
      
      fileDetails.push(<tr key={'file-'+totalFiles+'-'+index} onContextMenu={() => {
        let menuContextual = (<>
          <li key={'option-dw-'+index} className="list-group-item">
            <button className="btn text-secondary"
              onClick={() => { descargarArchivo(file.id_archivo_unico, file.nombre, file.tamanio) }}
              data-bs-toggle="tooltip" data-bs-placement="top" title=""
              >
              <i className="bi bi-cloud-download"></i> Descargar
            </button>
          </li>
          <li key={'option-del-'+index} className="list-group-item">
            <button className="btn text-secondary"
              onClick={() => { borrar(file.id_archivo_unico, file.nombre, 'delete'); }}
              data-bs-toggle="tooltip" data-bs-placement="top" title=""
              data-original-title="Delete">
              <i className="bi bi-trash"></i> Borrar
            </button>
          </li>
        </>);
        setMenuContextual(menuContextual);
      }} className={`border-bottom border-dark ${isSelected ? 'table-active' : ''}`}>
        {selectMode && (
          <td className="col-1 align-middle text-center">
            <input
              type="checkbox"
              className="form-check-input"
              checked={isSelected}
              onChange={() => handleFileSelect(file.id_archivo_unico)}
            />
          </td>
        )}
        <td className="col-1 align-middle text-center">
          {file.thumb ? 
            <img src={'public/'+file.thumb} width={50}/> : 
            <i className={'bi '+icono+' fs-3'}></i> 
          }          
        </td>
        <td className={`${selectMode ? 'col-8' : 'col-9'}`}>
          <span title={file.nombre}>{file.nombre}</span>
          <br/>
          <span title={file.date} style={{fontSize:'small'}}>
            {file.fecha.split(' ')[0]} - {formatBytes(file.tamanio)}
          </span>
        </td>
        <td className="col-1 align-middle text-center"><span title={file.os} style={{fontSize:'small'}}>{file.os}</span></td>
        <td className="col-1 align-middle text-center">
          <div className="dropdown show">
            <button type="button" className='border-0 bg-transparent' id="dropdownMenuArchivo" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{color:"#212529"}}>
              <i className="bi bi-three-dots-vertical"></i>
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuArchivo">
              <li key={'dwFile'+index}><button onClick={() => { descargarArchivo(file.id_archivo_unico, file.nombre, file.tamanio) }}
                className="dropdown-item"><i className="bi bi-cloud-download"></i> Descargar</button></li>
              {file.sharetoken ?
                <li key={'shFile'+index}>
                  <CopyToClipboard text={'https://neurokratos.space/s/'+file.sharetoken}>
                    <button className="dropdown-item" type="button">
                      <i className="bi bi-share"></i> Copiar Enlace
                    </button>
                  </CopyToClipboard>               
                </li>              
                :
                <li key={'shFile'+index}>
                  <button onClick={() => compartir(file.id_archivo_unico, 'share')} 
                          className="dropdown-item" 
                          type="button">
                    <i className="bi bi-share"></i> Compartir
                  </button>
                </li> 
              }
              {/* <li key={'shFile'+index}><a onClick={() => { compartir(file.id_archivo_unico, 'share'); }}
                className="dropdown-item" href="#"><i className="bi bi-share"></i> Compartir</a></li> */}
              <li key={'mvFile'+index}><button onClick={() => { mover(file.id_archivo_unico, file.nombre, 'mover') }}
                className="dropdown-item"><i className="bi bi-arrows-move"></i> Mover</button></li>
              <li key={'div'+index}><hr className="dropdown-divider"/></li>
              <li key={'delFile'+index}><button onClick={() => { borrar(file.id_archivo_unico, file.nombre, 'delete'); }}
                className="dropdown-item"><i className="bi bi-trash"></i> Borrar</button></li>
              {file.sharetoken ?
                <>
                <li key={'div'+index}><hr className="dropdown-divider"/></li>
                <li key={'endSh'+index}>
                    <button className="dropdown-item" onClick={() => { terminarCompartir(file.id_archivo_unico) }}>
                      <i className="bi bi-slash-circle"></i> Terminar de Compartir
                    </button>            
                </li>
                </>             
                :
                false
              }
            </ul>
          </div>
        </td>
      </tr>);
    }

    return (
      <div className="table-responsive h-100 w-100" style={{minHeight:'70vh'}}>
        <table className="table">
          <tbody>
            {selectMode ? renderTop(totalDir, totalFiles):null}
            {fileDetails}
          </tbody>
        </table>
      </div>
    );
  };
  const renderRecent = () => {
    return (
      <div className="col-12 text-center" style={{paddingTop:'10%'}}>
        <span className="fs-2">Los archivos recientes se mostrarán aqui</span>
      </div>
    );
  };
  const renderDirs = () => {
    let arrayDir = files.directories;
    let totalDir = arrayDir?.length;
    let list = [];
    if (totalDir == 0) {
      list.push(<tr key={"nonedir"} className={`border-bottom border-dark`}><td className='col'> No hay carpetas</td></tr>);
    }
    for (let j = 0; j < totalDir; j++) {
        const archivo = arrayDir[j];
        const dir = selectedDirs.has(archivo.id_carpeta);
        if (!dir) {
          list.push(
            <tr key={"dir"+totalDir+'-'+j} className={`border-bottom border-dark`}>
              <td className="col-1 align-middle text-center" onClick={() => {cambiarUbicacion(archivo.id_carpeta, archivo.nombre, activeTab); setBreadcrumb(prev => [...prev, archivo.nombre]);}}>
                <i className="bi bi-folder-fill folder fs-3"></i></td>
              <td className="col-11" onClick={() => {cambiarUbicacion(archivo.id_carpeta, archivo.nombre, activeTab); setBreadcrumb(prev => [...prev, archivo.nombre]);}} >
                <span>{decodeURIComponent(archivo.nombre)}</span>
                <br></br>
                <span style={{fontSize:'small'}}>Carpeta</span>
              </td>
            </tr>
          );
        }
    }

    if (list.length == 0) {
      list.push(<tr key={"nonedir"} className={`border-bottom border-dark`}><td className='col'> No hay carpetas destino disponibles</td></tr>);
    }
    return list;
  };
  return (
      <>
        <div className="overflow-auto" style={{height:`${movil === true ? '80vh' : '90vh'}`}}>
          <div className="btn-toolbar justify-content-end sticky-top" role="toolbar" id="" style={{backgroundColor:'var(--bs-body-bg)'}}>
            <span className="fs-6">{ubicacion !== '/' ?
              <button type="button" className="btn btn-outline-dark btn-sm" data-bs-toggle="tooltip" data-bs-placement="bottom" title="" 
                onClick={() => { regresarDirectorio(); setBreadcrumb(prev => prev.slice(0, -1));}}>
                <i className="bi bi-arrow-left"></i>
              </button> :
              ''}
            </span>
              <div className="btn-group" role="group">
                <button className="btn btn-outline-dark border-0 dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  {mayorMenor == 1 ?
                    <i className="bi bi-sort-up"></i>
                    :
                    <i className="bi bi-sort-down"></i>
                  }Ordernar <span className="caret"></span>
                </button>
                <ul className="dropdown-menu">
                  <li key={'orderNombre'}><a onClickCapture={() => { cambioFiltro("nombre", mayorMenor) }} className="dropdown-item" href="#">Nombre {(() => {
                    if (tipoFiltro == "nombre") return <i className="bi bi-check"></i>;
                    })()}</a></li>
                  <li key={'orderSize'}><a onClickCapture={() => { cambioFiltro("tamaño", mayorMenor) }} className="dropdown-item" href="#">Tamaño {(() => {
                    if (tipoFiltro == "tamaño") return <i className="bi bi-check"></i>;
                    })()}</a></li>
                  <li key={'orderTipo'}><a onClickCapture={() => { cambioFiltro("tipo", mayorMenor) }} className="dropdown-item" href="#">Tipo {(() => {
                    if (tipoFiltro == "tipo") return <i className="bi bi-check"></i>;
                    })()}</a></li>
                  <li key={'orderFecha'}><a onClickCapture={() => { cambioFiltro("fecha", mayorMenor) }} className="dropdown-item" href="#">Fecha {(() => {
                    if (tipoFiltro == "fecha") return <i className="bi bi-check"></i>;
                    })()}</a></li>
                  <li><hr className="dropdown-divider"/></li>
                  <li key={'cambioMayorMenorA'}><a onClickCapture={() => { cambioMayorMenor(tipoFiltro); }} className="dropdown-item" href="#">Ascendente {(() => {
                      if (mayorMenor == 1) return <i className="bi bi-check"></i>;
                    })()}</a></li>
                  <li key={'cambioMayorMenorD'}><a onClickCapture={() => { cambioMayorMenor(tipoFiltro); }} className="dropdown-item" href="#">Descendente {(() => {
                      if (mayorMenor != 1) return <i className="bi bi-check"></i>;
                    })()}</a></li>
                  {/* {filtros} */}
                </ul>
              </div>
              <div className="btn-group" role="group">
                <button className="btn btn-outline-dark border-0 dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  {vistaActual == 'detalles' ? <i className="bi bi-list-columns"></i> : <i className="bi bi-grid"></i>}
                </button>
                <ul className="dropdown-menu">
                  <li key={'vistaDetalles'}><a className="dropdown-item" href="#" 
                    onClickCapture={() => {
                      setVistaActual("detalles");
                    }}><i className="bi bi-list-columns"></i> Lista {(() => {
                      if (vistaActual == "detalles") return <i className="bi bi-check"></i>;
                    })()}</a>
                  </li>
                  <li key={'vistaCuadros'}><a className="dropdown-item" href="#" 
                    onClickCapture={() => {
                      setVistaActual("cuadros");
                    }}><i className="bi bi-grid"></i> Mosaicos {(() => {
                      if (vistaActual == "cuadros") return <i className="bi bi-check"></i>;
                    })()}</a>
                  </li>
                </ul>
              </div>
              <div className="btn-group" role="group">
                <button className={`btn btn-outline-dark border-0`} id="btnSelect" type="button"
                onClick={toggleSelectMode}>
                  <i className="bi bi-check-square"></i> Seleccionar
                </button>
              </div>
          </div>
          
          <div ref={containerRef} className="" id="contenedor_archivos_drive"
            onMouseOver={(e) => { e.stopPropagation();e.preventDefault(); }}
            onMouseLeave={(e) => { e.stopPropagation();e.preventDefault(); }}
            onDragLeave={(e) => {
              e.stopPropagation();e.preventDefault();
              let element = document.getElementById("contenedor_archivos_drive");
              element.className = 'col-12 overflow-y-auto';
            }}
            onDragEnter={(e) => { e.stopPropagation(); e.preventDefault(); }}
            onDragOver={(e) => { e.stopPropagation(); e.preventDefault(); 
              let element = document.getElementById("contenedor_archivos_drive");
              element.className = 'col-12 overflow-y-auto border border-3 border-info shadow opacity-50';
            }}
            onDrop={(e) => {
              e.stopPropagation(); e.preventDefault();
              //console.log(e);
              let element = document.getElementById("contenedor_archivos_drive");
              element.className = 'col-12 overflow-y-auto';
              let ventanaSubida = document.getElementById('ventanaSubida');
              ventanaSubida.className = "col-4 bg-white";

              if (e.dataTransfer.items) {
                // Use DataTransferItemList interface to access the file(s)
                [...e.dataTransfer.items].forEach((item, i) => {
                  // If dropped items aren't files, reject them
                  if (item.kind === "file") {
                    const file = item.getAsFile();
                    console.log(`… file[${i}].name = ${file.name}`);
                  }
                });
              } else {
                // Use DataTransfer interface to access the file(s)
                [...e.dataTransfer.files].forEach((file, i) => {
                  console.log(`… file[${i}].name = ${file.name}`);
                });
              }
            }}>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb" style={{fontSize:'x-large'}}>
                {
                breadcrumb.map((bc, index) => {
                  if(index === breadcrumb.length - 1)
                    return <li key={'bc'+index} className="breadcrumb-item text-info">{bc}</li>
                  else
                    return <li key={'bc'+index} className="breadcrumb-item">{bc}</li>
                })
                }                        
              </ol>
            </nav>
            {activeTab === 'inicio' && files.files?.length === 0 ? renderRecent():''}
            {vistaActual === 'cuadros' ? renderGrid() : renderList()}
            
          </div>
          {showAlert && (
            <div className="toast-container position-fixed end-0 p-2" style={movil?{bottom:'10%'}:{bottom:'2%'}}>
              <div id="liveToast" className={`toast show border-${alert[0].type}`} role="alert" aria-live="assertive" aria-atomic="true">
                <div class="toast-header">
                  <i class="bi bi-envelope me-1"></i>
                  <strong class="me-auto">
                    {alert[0].or}
                  </strong>
                  <button type="button" class="btn-close" aria-label="Close" onClick={()=>{setShowAlert(false);}}></button>
                </div>
                <div className={`toast-body`}>
                  {alert[0].msg}
                </div>
              </div>
            </div>)}
          {selectMode && (
            <div className="row z-3" >
              <div className="btn-group-vertical p-0" role="group" style={{maxWidth: '90px', bottom: '10vh', position: 'fixed', right:'0px'}}>
                {/* <button 
                className="btn btn-primary"
                onClick={() => {
                    console.log('share files:');
                    // Process selected files here
                }}
                disabled={selectedFiles.size === 0 && selectedDirs.size === 0}>
                <i className="bi bi-share fs-5"></i><br/>
                <small>Compartir</small>
                </button> */}

                <button 
                className="btn btn-primary"
                onClick={() =>mover('', '', 'moveMultiple')}
                disabled={selectedFiles.size === 0 && selectedDirs.size === 0}>
                <i className="bi bi-folder-symlink fs-5"></i><br/>
                <small>Mover</small>
                </button>

                <button 
                className="btn btn-primary"
                disabled={selectedFiles.size === 0 && selectedDirs.size === 0}
                onClick={() => borrar('', '', 'deleteMultiple') }>  
                <i className="bi bi-trash fs-5"></i><br/>
                <small>Borrar</small>
                </button>

                <button 
                className="btn btn-primary"
                onClick={() => unSelect() }
                disabled={selectedFiles.size === 0 && selectedDirs.size === 0}>
                <i className="bi bi-backspace fs-5"></i><br/>
                <small>De-seleccionar</small>
                </button>

                <button 
                className="btn btn-primary" 
                onClick={() => toggleSelectMode()}>
                <i className="bi bi-x fs-5"></i><br/>
                <small>Cancelar</small>
                </button>
              </div>
            </div>
          )}
        </div>

        {showModal && (
          <div className="modal show d-block" id="modalDrive" tabIndex="-1" data-bs-backdrop="static">
          <div className="modal-backdrop show z-n1"></div>
          <div className={`modal-dialog ${modalType === 'delete' || modalType === 'share' ? 'modal-dialog-centered modal-lg':'modal-fullscreen'}`}>
              <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">
                      {modalType === 'move' && 'Mover'}
                      {modalType === 'dw' && 'Descarga'}
                      {modalType === 'dwDir' && 'Descarga Carpeta'}
                      {modalType === 'delete' && 'Borrar'}
                      {modalType === 'share' && 'Compartir'}
                    </h5>
                    {modalType === 'share' && (<button type="button" class="btn-close" aria-label="Close" onClick={() => { setShareUrl(''); setArchivoShare([]); setCopy(false); setShowModal(false);}}></button>)}
                </div>
                <div className="modal-body">
                  {modalType === 'move' && (<>
                    <nav aria-label="breadcrumb">                      
                      <ol className="breadcrumb">
                        {ubicacion !== '/' ?
                        <li type="button" className="btn btn-outline-dark btn-sm me-3" data-bs-toggle="tooltip" data-bs-placement="bottom" title="" 
                          onClick={() => { regresarDirectorio(); setBreadcrumb(prev => prev.slice(0, -1));}}>
                          <i className="bi bi-arrow-left"></i>
                        </li> : ''}
                        {
                        breadcrumb.map((bc, index) => {
                          if(index === breadcrumb.length - 1)
                            return <li className="breadcrumb-item text-info">{bc}</li>
                          else
                            return <li className="breadcrumb-item">{bc}</li>
                        })
                        }                        
                      </ol>
                    </nav>
                    <table className="table">
                      <tbody>{renderDirs()}</tbody>
                    </table>
                    </>
                  )}
                  {modalType === 'dw' && (
                    <>
                    <div className="row">
                      Descargando su archivo...
                    </div>
                    <div className="row">
                      <div className="progress" role="progressbar" aria-label="progress-descarga" aria-valuenow={pg} aria-valuemin="0" aria-valuemax="100">
                        <div className="progress-bar" style={{ width: pg + "%" }}>{pg + "%"}</div>
                      </div>
                    </div>
                    </>
                  )}
                  {modalType === 'dwDir' && (
                    <>
                    <div className="row">
                      {errorDw !== '' ? 
                      <div class="alert alert-danger" role="alert">
                        {errorDw}
                      </div>
                      :statusDw}
                    </div>
                    <div className="row">
                      <div className="progress" role="progressbar" aria-label="progress-descarga" aria-valuenow={pg} aria-valuemin="0" aria-valuemax="100">
                        <div className="progress-bar" style={{ width: pg + "%" }}>{pg + "%"}</div>
                      </div>
                    </div>
                    </>
                  )}
                  {modalType === 'delete' && (
                    <div className='col-12'>
                      <span className='fs-4'>¿Está seguro de borrar el archivo, esta acción es irreversible?</span><br/>
                      {errorFile !== '' && (
                        <div className="alert alert-warning" role="alert">
                          {errorFile}
                        </div>
                      )}
                    </div>
                  )}
                  {modalType === 'deleteDir' && (
                    <div className='col-12'>
                      <span className='fs-4'>¿Está seguro de borrar la carpeta, esta acción es irreversible?</span><br/>
                      {errorFile !== '' && (
                        <div className="alert alert-warning" role="alert">
                          {errorFile}
                        </div>
                      )}
                    </div>
                  )}
                  {modalType === 'share' && (
                    <div className='col-12'>
                      {shareUrl === '' && (<div className="spinner-border text-primary" role="status"></div>)}
                      {shareUrl !== '' && (<>
                      <p className='text-wrap text-break'>{shareUrl}</p>                      
                      <div class="d-grid gap-2">
                        <CopyToClipboard text={shareUrl} onCopy={() => setCopy(true)}>
                          <button type="button" className="btn btn-primary">
                            <i className="bi bi-clipboard"></i> Copiar enlace
                          </button>
                        </CopyToClipboard>
                      </div>
                      {copy && (<small className='text-success'>Copiado!</small>)}
                      </>)}
                    </div>
                  )}
                </div>
                <div className="modal-footer">
                  {modalType === 'move' && (<>
                    {/* {ubicacion === '/' ? '':<button type="button" className="btn btn-primary" onClick={() => { moverArchivos(); setBreadcrumb([]);}}>Mover aqui</button>} */}
                    <button type="button" className="btn btn-primary" onClick={() => { 
                      moverArchivos(); 
                      setBreadcrumb([]);}}>Mover aqui</button>
                    <button type="button" className="btn btn-secondary" onClick={() => { 
                      cambiarUbicacion?.('','/', activeTab);
                      setTimeout(() => {
                        setBreadcrumb([]);
                        setShowModal(false); 
                      }, 500);                      
                      }}>Cancelar</button>
                    </>
                  )}
                  {modalType === 'delete' && (<>
                    <button type="button" className="btn btn-primary" onClick={() => { borrarArchivos(); }}>Borrar</button>
                    <button type="button" className="btn btn-secondary" onClick={() => { setShowModal(false); }}>Cancelar</button>
                    </>
                  )}
                  {modalType === 'share' && (<>
                    <button type="button" className="btn btn-primary" onClick={() => {
                      setShareUrl(''); setArchivoShare([]); setCopy(false); setShowModal(false);                      
                      }}>Aceptar</button>
                    </>
                  )}
                  {modalType === 'dwDir' && (<>
                    <button type="button" className="btn btn-primary" onClick={() => { setShowModal(false); }}>Aceptar</button>
                    {/* <button type="button" className="btn btn-secondary" onClick={() => { setShowModal(false); }}>Cancelar</button> */}
                    </>
                  )}
                </div>
              </div>
          </div>
          </div>
        )}

        <div id="MenuDesplagableSecundario" style={{ position: "absolute", display: "none", zIndex: "100" }}>
          <div className="card" style={{ width: "12rem" }}>
            <ul className="list-group list-group-flush">
              {menuContextual}
            </ul>
          </div>
        </div>
      </>
  );
};

export default Drive;